<template>
  <form @submit.prevent="update">
    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
      <div class="pb-8 pr-6 w-full lg:w-1/2" v-if="user.data.avatar">
        <img class="block ml-4 w-32 h-32 rounded-full" :src="user.data.avatar" />
      </div>

      <div class="pb-8 pr-6 w-full lg:w-1/2 flex">
        <div class="w-1/2">
          <label class="form-label" for="active">Actief</label>
          <JetCheckbox id="active" v-model:checked="form.active" name="active" />
        </div>
        <div class="w-1/2">
          <label class="form-label" for="ambassador">Ambassadeur</label>
          <JetCheckbox id="ambassador" v-model:checked="form.ambassador" name="ambassador" />
        </div>

        <!-- <div class="w-1/2">
          <label class="form-label" for="public_point">Boekenbuurpunt</label>
          <JetCheckbox
            id="public_point"
            v-model:checked="form.public_point"
            name="public_point"
          />
        </div> -->
      </div>

      <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2"
        label="Voornaam" />

      <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2"
        label="Achternaam" />
      <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="E-mail" />

      <text-input v-model="form.membership_id" :error="form.errors.membership_id" class="pb-8 pr-6 w-full lg:w-1/2"
        label="Lidnummer BHL" />

      <text-input :modelValue="user.data.street.data.municipality.data.name" class="pb-8 pr-6 w-full lg:w-1/2"
        label="Wijk" disabled="disabled" />
      <text-input :modelValue="user.data.street.data.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Straat"
        disabled="disabled" />
      <text-input :modelValue="user.data.street_number" class="pb-8 pr-6 w-full lg:w-1/2" label="Huisnummer"
        disabled="disabled" />
    </div>

    <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
      <loading-button :loading="form.processing" class="btn-indigo" type="submit">Gebruiker bijwerken</loading-button>
    </div>
  </form>
</template>

<script>
import TextInput from "@/Shared/TextInput";
import LoadingButton from "@/Shared/LoadingButton";
import JetCheckbox from "@/Jetstream/Checkbox.vue";

export default {
  components: {
    LoadingButton,
    TextInput,
    JetCheckbox,
  },
  props: {
    user: Object,
  },
  remember: "form",
  data() {
    return {
      form: this.$inertia.form({
        ambassador: this.user.data.ambassador,
        // public_point: this.user.data.public_point,
        active: this.user.data.active,
        first_name: this.user.data.first_name,
        last_name: this.user.data.last_name,
        email: this.user.data.email,
        membership_id: this.user.data.membership_id,
        // public_request: this.user.data.public_request,
      }),
    };
  },
  methods: {
    update() {
      this.form.put(`/users/${this.user.data.id}`);
    },
  },
};
</script>

